<template>
  <div class="like-dislike-container">
    <div class="like-wrapper" v-has-permission="'lives_dtable_show_like'" has-permission="lives_dtable_show_like">
      <i class="icon-thumbs-up"></i> {{ nbLike }}
    </div>
    <div class="like-wrapper like-wrapper__dislike" v-has-permission="'lives_dtable_show_not_like'" has-permission="lives_dtable_show_not_like">
      <i class="icon-thumbs-up"></i> {{ nbNotLike }}
    </div>
  </div>
</template>

<script>
import HasPermission from '../../directives/HasPermission.js';

export default {
  name: 'LikeDislike',
  props: {
    nbLike: {
      type: Number,
      default: 0,
    },
    nbNotLike: {
      type: Number,
      default: 0,
    },
  },
  directives: {
    HasPermission,
  },
};
</script>

<style lang="scss" scoped>
.like-dislike-container {
  display: flex;
  font-size: 0.8em;
  font-weight: 500;
  .like-wrapper {
    margin-right: 0.5em;
    &__dislike {
      i {
        transform: rotate(180deg);
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/components/LikeDislike.vue